import { compose } from 'redux'
import { connect } from 'react-redux'
import { setJsonGerarOkReportDeveloper } from '../../actions'

import { withRouter } from 'react-router-dom'
const mapStateToProps = (state, props) => {
    return {};
};


export default compose(
    withRouter,
    connect(mapStateToProps, { setJsonGerarOkReportDeveloper })

);


// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/BotaoEnviaJson/BotaoEnviaJson.enhancer.js